export const iconFontAwesomeDisasterCrisisWheatAwnCircleExclamation = (
	<i className="fa-solid fa-wheat-awn-circle-exclamation"></i>
);
